import "./sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "nprogress/nprogress.css";
import App from "./App.tsx";
import { Provider } from "react-redux";
import { store } from "./api/store.ts";
import { ThemeProvider } from "@mui/material";
import { theme } from "./assets/theme.ts";
import SessionProvider from "./context/SessionProvider";
import * as Sentry from "@sentry/react";
import ErrorBoundaryProvider from "./context/ErrorBoundaryProvider/ErrorBoundaryProvider.tsx";

const container = document.getElementById("root")!;

const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <SessionProvider>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <ErrorBoundaryProvider>
            <App />
          </ErrorBoundaryProvider>
        </ThemeProvider>
      </Provider>
    </SessionProvider>
  </StrictMode>,
);
